<script>
	module.exports = {
		components: {
			'library-product-card': require('components/library-product-card.vue').default,
			'load-mask': require('components/load-mask.vue').default
		},
		props: ['loading', 'getMoreResults'],
		modelData: ['libraryResults', 'q'],
		computed: {
			results() {
				let libraryResults = this.libraryResults;
				let hits = [];

				if (libraryResults && libraryResults.hits) {
					hits = libraryResults.hits;
				}
				return hits;
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.library-search-results {
		padding-top: 2rem;
		position: relative;
		min-height: 10rem;

		.title {
			display: flex;
			align-items: center;

			.hit-count {
				flex: 1;
				text-align: right;
			}
		}

		.library-search-results-inner {
			display: flex;
			flex-wrap: wrap;
		}

		.library-product-card {
			vertical-align: top;
		}

		.get-more-wrapper {
			padding: 2rem 0;
		}
	}
</style>
<template>
	<div class="library-search-results">
		<load-mask
			v-if="loading"
			:text="'Searching...'"></load-mask>
		<template v-if="results && results.length">
			<div class="title wrapper">
				<h2>Search Results {{ q ? 'for "' + q + '"' : '' }}</h2>
			</div>
			<div class="library-search-results-inner wrapper">
				<library-product-card
					v-for="(item, index) in results"
					:key="item.id"
					:id="item.id"
					:img="item.img_highres2"
					:img-alt="item.imgAlt"
					:title="item.title"
					:topics="item.libraryTopics"
					:article-index="index"
					:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
				</library-product-card>
			</div>
		</template>
		<template v-else>
			<div class="title wrapper">
				<h2>No results found.</h2>
			</div>
		</template>
		<div
			v-if="getMoreResults"
			class="get-more-wrapper wrapper text-centered">
			<div
				class="button"
				@click="getMoreResults">
				Get More
			</div>
		</div>
	</div>
</template>
